import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { StorageService } from "../storageService.service";

@Injectable()
export class UrlAirlineInterceptor implements HttpInterceptor {

    private airlineIdRegex = /:airline_id:/g;
    private airlineCodeRegex = /:airline_code:/g;
    private airlineUpperCodeRegex = /:airline_CODE:/g;

    constructor(
        private storage: StorageService
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        
        if(
            !this.airlineIdRegex.test(req.url) && 
            !this.airlineCodeRegex.test(req.url) &&
            !this.airlineUpperCodeRegex.test(req.url)) {
            return next.handle(req);
        }

        const currentAirline = this.storage.get.currentAirline();
        const url = (req.url as string)
            .replace(this.airlineIdRegex, currentAirline.id)
            .replace(this.airlineCodeRegex, currentAirline.code)
            .replace(this.airlineUpperCodeRegex, currentAirline.code.toUpperCase());
        const updatedReq = req.clone({ url: url });
        return next.handle(updatedReq);
    }
}